import { CheckBoxInput, TextInput, TimeInput } from "../ui/Inputs";

const KioskRestrictIntervalTable = ({
    dayFlag,
    data,
    deleteChk,
    DaysFlag,
    handleChange,
    handleOnBlur,
    handleDeletelockKioskchange,
    errorMessage,
}) => {
    return (
        <div className="table-responsive">
            <table className="table table-bordered table-striped table-sm align-middle">
                <thead>
                    <tr>
                        <th style={{ color: '#fff', backgroundColor: '#c8605e' }}>From</th>
                        <th style={{ color: '#fff', backgroundColor: '#c8605e' }}>To</th>
                        <th style={{ color: '#fff', backgroundColor: '#c8605e' }}>For</th>
                        <th className="text-center" style={{ color: '#fff', backgroundColor: '#c8605e' }}>Delete</th>
                    </tr>
                </thead>

                <tbody>
                    {data?.length > 0 ? (
                        data.map((row, i) => (
                            <tr key={row.RandomID ?? i}>
                                {/* FROM */}
                                <td style={{ minWidth: '100px', maxWidth: '100px' }}>
                                    <TimeInput
                                        handleChange={(e) =>
                                            handleChange(e, row, i, dayFlag)
                                        }
                                        cName={`date-icon-1 LockFromTime${dayFlag}${i}`}
                                        name={`kioskRestrictIntervalFillAll[${dayFlag}].[${i}].LockFromTime`}
                                        value={data?.[i]?.LockFromTime || ""}
                                        placeholder="02:00"
                                        errorMessage={errorMessage}
                                    />
                                </td>

                                {/* TO */}
                                <td style={{ minWidth: '100px', maxWidth: '100px', }}>
                                    <TimeInput
                                        handleChange={(e) =>
                                            handleChange(e, row, i, dayFlag)
                                        }
                                        cName={`date-icon-1 LockToTime${dayFlag}${i}`}
                                        name={`kioskRestrictIntervalFillAll[${dayFlag}].[${i}].LockToTime`}
                                        value={data?.[i]?.LockToTime || ""}
                                        placeholder="03:24"
                                        errorMessage={errorMessage}
                                    />
                                </td>

                                {/* FOR */}
                                <td style={{ minWidth: '200px', maxWidth: '200px' }}>
                                    <TextInput
                                        placeholder="Enter for"
                                        handleChange={(e) =>
                                            handleChange(e, row, i, dayFlag)
                                        }
                                        handleBlur={(e) =>
                                            handleOnBlur(e, row, i, dayFlag)
                                        }
                                        cName={`IntervalType${dayFlag}${i}`}
                                        name={`kioskRestrictIntervalFillAll[${dayFlag}].[${i}].IntervalType`}
                                        id={`kioskRestrictIntervalFillAll[${dayFlag}].[${i}].IntervalType`}
                                        value={data?.[i]?.IntervalType || ""}
                                        errorMessage={errorMessage}
                                        maxLength={50}
                                    />
                                </td>

                                {/* DELETE */}
                                <td className="text-center">
                                    <CheckBoxInput
                                        label=""
                                        name={`Checkbox_${dayFlag}_${i}`}
                                        value={`${dayFlag}_${i}`}
                                        handleClick={(e) =>
                                            handleDeletelockKioskchange(
                                                e,
                                                dayFlag,
                                                row.RandomID
                                            )
                                        }
                                        checked={
                                            deleteChk?.some(
                                                (chk) =>
                                                    chk[`Checkbox_${dayFlag}_${i}`] === true
                                            ) ?? false
                                        }
                                    />
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan={4} style={{ color: '#c8605e', fontSize: '16px' }} className="text-center">
                                No data found
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};
export default KioskRestrictIntervalTable;